// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"312":"f7c9ba49","929":"034232ea"}[chunkId] + ".css";
};